/*
 * @Author: wwlsky
 * @Date: 2025-05-19 15:54:47
 * @LastEditTime: 2025-05-21 09:38:04
 */
/**
 * Axios configuration for API requests
 * @module api/axios
 */
import axios from 'axios';

/**
 * Base API instance with common configuration
 */
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_API_URL || 'https://museum.hzsdgames.com/api'
    : 'http://localhost:4901/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor to add authorization token
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

/**
 * Response interceptor to handle common errors
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors (token expired, etc.)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default api;
